import { useEffect, useState } from "react";
import $ from 'jquery';

import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';

import { images } from "./imagesToLoad";

import Header from './components/Header'

import Home from './pages/Home'
import AboutUs from "./pages/AboutUs";
import Consultation from "./pages/Consultation";

function AppContent() {
  const location = useLocation();

  const pageVariants = {
    initial: { opacity: 0, y: 0 },
    in: { opacity: 1, x: 0 },
    out: { opacity: 0, y: -20 },
  };

  const pageTransition = {
    type: "tween",
    ease: "anticipate",
    duration: 0.5
  };

  return (
    <>
      <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="/"
          element={
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              <Home />
            </motion.div>
          }
        />
        <Route
          path="/about-us"
          element={
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              <AboutUs />
            </motion.div>
          }
        />
        <Route
          path="/consultation"
          element={
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              <Consultation />
            </motion.div>
          }
        />
      </Routes>
    </AnimatePresence>
    
    </>
    
  );
}

function App() {
  const [isLoading, setIsLoading] = useState(true);

  const loadImage = (image) => {
    return new Promise((resolve, reject) => {
      const newImage = new Image();
      newImage.src = image;
      newImage.onload = () => resolve(image);
      newImage.onerror = (err) => reject(err);
    });
  };

  useEffect(() => {
    $('body').addClass("ovf-hidden");
    Promise.all(images.map(loadImage))
      .then(() => setIsLoading(false))
      .catch((err) => {
        console.log("Failed to load images", err);
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    if (!isLoading) {
      $('body').removeClass("ovf-hidden");
      $('#loader').addClass("hide");
    }
  }, [isLoading]);

        if (isLoading) return <div id="loader">Loading...</div>;

  return (
    <>

        <Router>
          <Header />
          <AppContent />
        </Router>
      
    </>
    
  );
}

export default App;


